import { Button, Modal, FormLayout, Form, LegacyStack, Select, Link } from '@shopify/polaris';
import { useImperativeHandle } from 'react';
import { forwardRef } from 'react';
import { useState, useCallback, useEffect } from 'react';
import { getCustomersList } from '../../../services/customersService';
import { getDeposits } from '../../../services/depositsService';

export const NewSellModal = forwardRef(({ onAddSell }, ref) => {
  const [deposits, setDeposits] = useState([]);
  const [optionsDeposits, setOptionsDeposits] = useState(1);
  const [customers, setCustomers] = useState([]);
  const [optionsCustomers, setOptionsCustomers] = useState(1);
  const [active, setActive] = useState(false);
  const handleChange = useCallback(() => setActive(!active), [active]);

  useImperativeHandle(ref, () => ({
    open() {
      setActive(true);
    },
  }));

  const defaultSell = {
    customerId: optionsCustomers,
    depositId: optionsDeposits,
  };

  const [sellForm, setSellForm] = useState(defaultSell);
  const activator = <Button onClick={handleChange}>Nueva venta</Button>;

  useEffect(() => {
    getDeposits({ limit: 1000 }).then((res) => {
      const p = res.data.data.map((d) => ({ label: d.name, value: parseInt(d.id) }));
      setDeposits(p);
    });
    getCustomersList({ limit: 1000 }).then((res) => {
      const c = res.data.data.map((d) => ({ label: d.name, value: parseInt(d.id) }));
      setCustomers(c);
    });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await onAddSell(sellForm);
      setSellForm(defaultSell);
      setActive(false);
    } catch (e) {}
  };

  const handleDeposit = (value) => {
    setSellForm({
      ...sellForm,
      depositId: parseInt(value),
    });
    setOptionsDeposits(parseInt(value));
  };

  const handleCustomers = (value) => {
    setSellForm({
      ...sellForm,
      customerId: parseInt(value),
    });
    setOptionsCustomers(parseInt(value));
  };

  return (
    <Modal activator={activator} open={active} onClose={handleChange} title="Crear nueva venta">
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <Select
              label="Selecciona un cliente"
              options={customers}
              onChange={handleCustomers}
              value={optionsCustomers}
            />
            <LegacyStack distribution="trailing">
              <Link plain to="/customers/page/1">
                Añadir cliente
              </Link>
            </LegacyStack>
            <Select
              label="Selecciona un depósito"
              options={deposits}
              onChange={handleDeposit}
              value={optionsDeposits}
            />
            <LegacyStack distribution="center">
              <Button submit primary size="slim">
                CREAR
              </Button>
            </LegacyStack>
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
});
